// src\components\Payroll\ProcessPartialSalaryFld\shared\ProcessBatchForm.jsx
import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";

/**
 * ProcessBatchForm
 *
 * Props:
 *   isOpen          — boolean
 *   onClose         — () => void
 *   batches         — array of batch objects
 *   onProcess       — (batchId, require15DayStreak, onClose) => void
 */
export const ProcessBatchForm = ({ isOpen, onClose, batches, onProcess }) => {
  const [batchId, setBatchId] = useState("");
  const [require15DayStreak, setRequire15DayStreak] = useState(false);
  const [errorState, setErrorState] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setBatchId("");
      setRequire15DayStreak(false);
      setErrorState(false);
    }
  }, [isOpen]);

  const submit = () => {
    if (!batchId) { setErrorState(true); return; }
    onProcess(batchId, require15DayStreak, onClose);
    setErrorState(false);
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay open">
      <div className="modal">
        <div className="popUp-header row">
          <div className="popUp-title">
            <h3 style={{ color: "#668fca" }}>Process Partial Salary</h3>
          </div>
          <div className="popUp-close"><CloseIcon onClick={onClose} /></div>
        </div>

        <div className="popUp-body column" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>

          {/* Batch select */}
          <div className="popUp-item info-item column">
            <div className="info-item-label">Batch</div>
            <div className="info-item-input">
              <select
                value={batchId}
                onChange={(e) => setBatchId(e.target.value)}
                style={{ color: batchId ? "rgb(104,104,104)" : "rgba(0,0,0,0.356)" }}
              >
                <option value="" disabled hidden>Select a batch</option>
                {batches.map((b) => (
                  <option key={b.id} value={b.id}>
                    {`Batch #${b.id} — ${b.payrollPeriodIdentifier || b.payrollPeriodName || `Period ${b.payrollPeriodId}`} | ${b.effectiveDate ? b.effectiveDate.split("T")[0] : ""} | ${b.status ?? "—"}`}
                  </option>
                ))}
              </select>
            </div>
            <span style={{ visibility: !batchId && errorState ? "visible" : "hidden", color: "#ff6565", fontSize: "12px" }}>
              Please select a batch
            </span>
          </div>

          {/* require15DayStreak checkbox — mirrors payroll.js checkbox pattern */}
          <div className="popUp-item info-item row" style={{ alignItems: "center", marginTop: "10px" }}>
            <div className="info-item-input">
              <input
                type="checkbox"
                id="require15DayStreak-checkbox"
                className="checkbox"
                checked={require15DayStreak}
                onChange={(e) => setRequire15DayStreak(e.target.checked)}
              />
            </div>
            <div className="info-item-label" style={{ paddingLeft: "10px" }}>
              Complete 15 days of attendance within first cutoff
            </div>
          </div>

        </div>

        <div className="buttons row" style={{ justifyContent: "end", padding: "40px 40px 20px 40px" }}>
          <button className="save row" onClick={submit} style={{ marginRight: "5px" }}>PROCESS</button>
          <button className="cancel row" onClick={onClose}>CANCEL</button>
        </div>
      </div>
    </div>
  );
};